import React from 'react';

import {
  Stack,
  CircularProgress,
  Typography,
  Tooltip,
  InfoOutlinedIcon,
} from '@gogame/components';

import FilterDetails from './FilterDetails';

const COMPARED_TITLES = {
  0: 'Base',
  1: 'Compared',
};

const WidgetFilters = ({ data, isLoading, compareMode, getFilterTitle }) => {
  return (
    <Tooltip
      title={
        <Stack spacing={1} maxWidth={450}>
          {isLoading ? (
            <CircularProgress color={'inherit'} />
          ) : data ? (
            compareMode ? (
              <React.Fragment>
                {data.map((filters, i) => (
                  <Stack key={i}>
                    <Typography variant={'caption'}>
                      <b>{COMPARED_TITLES[i]}</b>
                    </Typography>
                    <FilterDetails
                      filters={filters}
                      getFilterTitle={getFilterTitle}
                    />
                  </Stack>
                ))}
              </React.Fragment>
            ) : (
              <Stack>
                <FilterDetails
                  filters={data[0]}
                  getFilterTitle={getFilterTitle}
                />
              </Stack>
            )
          ) : null}
        </Stack>
      }
      arrow={false}
      placement={'right-start'}
    >
      <InfoOutlinedIcon sx={{ fontSize: 16 }} color={'action'} />
    </Tooltip>
  );
};

export default WidgetFilters;
